import { alpha, Box, Popover, Tooltip, Typography } from "@mui/material";
import PermissionInfo from "components/permissionInfo";
import useLocales from "hooks/useLocales";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
import { getActive } from "utils/routes";
import { DotIcon, ListItem } from "./NavItem";
import { ListItemTextStyle } from "./style";

interface Props {
  anchorEl: HTMLElement | null;
  handlePopoverClose: () => void;
  submenu?: {
    path: string;
    title: string;
    disabled?: boolean;
    role?: Boolean;
    color?: string;
    locked?: boolean;
    caption?: string;
  }[];
  title: string;
  locked?: boolean;
}

const NavItemSubmenuPopover = ({
  anchorEl,
  handlePopoverClose,
  submenu,
  title,
  locked,
}: Props) => {
  const { translate } = useLocales();
  const { pathname } = useLocation();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: 60,
      }}
      onClose={handlePopoverClose}
      hideBackdrop
      //   sx={{
      //     pointerEvents: "none",
      //   }}
      PaperProps={{
        sx: {
          bgcolor: "background.paper",
          borderRadius: "8px",
          p: 1,
          display: "flex",
          flexDirection: "column",
          width: "200px",
          border: `1px solid ${alpha("#d0d7de", 0.5)}`,
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: "bold",
            color: "text.greyLight",
            fontSize: "12px",
            mb: 1,
            ml: 1,
          }}
          variant="subtitle2"
        >
          {translate(title)}
        </Typography>
        {locked && <PermissionInfo />}
      </Box>
      {submenu
        ?.filter((m) => m.role)
        .map((menu, index) => {
          const active = getActive(menu.path, pathname);
          return (
            <ListItem
              key={menu.path || index}
              {...(!menu.locked
                ? {
                    component: RouterLink,
                    to: menu.path,
                  }
                : {})}
              disabled={menu.disabled}
              //   role={menu.role}
              sx={{
                "&:hover, &.activeRoot, &.active": {
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              <DotIcon active={active} color={menu.color} />
              <ListItemTextStyle
                primary={translate(menu.title)}
                disableTypography
                sx={{
                  color: "text.greyLight",
                  fontWeight: active ? "bold" : "normal",
                  fontSize: "12px",
                }}
                secondary={
                  <Tooltip title={translate(menu.caption) || ""} arrow>
                    <Typography
                      noWrap
                      variant="caption"
                      component="div"
                      sx={{ textTransform: "initial", color: "text.greyLight" }}
                    >
                      {translate(menu.caption)}
                    </Typography>
                  </Tooltip>
                }
              />
              {menu.locked && <PermissionInfo />}
            </ListItem>
          );
        })}
    </Popover>
  );
};

export default NavItemSubmenuPopover;
